import { List, Divider, Stack, Typography, Paper } from '@mui/material';
import React, { type JSX } from 'react';
import SimpleCardSkeleton from '../SimpleCardSkeleton';
import { useTheme } from '@mui/material/styles';
import { CustomTransComponent } from 'components';

// Pure module-level helpers — keep decision points out of the component

const formatTimeDiff = (diff: any): string => {
    if (diff?.type === 'sec') return `${diff?.value} seconds ago`;
    if (diff?.type === 'min' && diff?.value < 60) return `${diff?.value} minutes ago`;
    return '';
};

const renderAlarmTime = (data: any, alarmOccurredDiff: any, convertDateTime: any): JSX.Element => {
    if (!data?.data?.alarmOccurred) {
        return (
            <Typography fontWeight="600" fontSize="15px" className="text-secondary">
                --
            </Typography>
        );
    }
    return (
        <>
            {alarmOccurredDiff && <Typography marginRight={2}>{formatTimeDiff(alarmOccurredDiff)}</Typography>}
            <Typography fontWeight="400" fontSize="15px" className="text-secondary">
                {convertDateTime({ timestamp: parseInt(data.data.alarmOccurred), customFormat: 'h:mm:ss' })}
            </Typography>
            <Typography
                fontWeight="600"
                fontSize="15px"
                className="text-secondary"
                sx={{ marginLeft: '4px', marginRight: '4px' }}
            >
                {convertDateTime({ timestamp: parseInt(data.data.alarmOccurred), customFormat: 'A' })}
            </Typography>
            <Typography fontWeight="400" fontSize="15px" className="text-secondary">
                {convertDateTime({ timestamp: parseInt(data.data.alarmOccurred) })}
            </Typography>
        </>
    );
};

const renderOccurredTrends = (trends: any): JSX.Element => {
    if (!trends || !Object.keys(trends)?.length) return <></>;
    return (
        <>
            {Object.keys(trends).map((item: any) => (
                <>
                    <Divider />
                    <Stack p={2} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                        <Typography className="text-secondary" variant="body1" fontSize={'14px'}>
                            {item}
                        </Typography>
                        <Typography className="text-secondary" fontWeight={'600'} fontSize={'14px'}>
                            {trends[item] ?? 0}
                        </Typography>
                    </Stack>
                    <Divider />
                </>
            ))}
        </>
    );
};

export const AlarmOccurred = ({
    isLoading,
    data,
    convertDateTime,
    alarmOccurredDiff,
}: {
    isLoading: boolean;
    data: any;
    convertDateTime: any;
    alarmOccurredDiff: any;
}): JSX.Element => {
    const theme: any = useTheme();
    return (
        <Paper>
            <List disablePadding>
                {isLoading ? (
                    <SimpleCardSkeleton count={6} />
                ) : (
                    <>
                        <Stack
                            direction={'row'}
                            alignItems={'center'}
                            justifyContent={'space-between'}
                            className="border-bottom-1"
                            p={2}
                        >
                            <Typography
                                sx={{ fontSize: '14px', color: theme?.palette?.primary?.main }}
                                fontWeight={'600'}
                            >
                                <CustomTransComponent translationKey={'TIMELINE:LAST_UPDATE_DETAILS'} />
                            </Typography>
                            <Stack direction="row" alignItems="center">
                                {renderAlarmTime(data, alarmOccurredDiff, convertDateTime)}
                            </Stack>
                        </Stack>

                        {renderOccurredTrends(data?.data?.occurredTrends)}
                    </>
                )}
            </List>
        </Paper>
    );
};
